import { makeStyles } from 'tss-react/mui';

export default () =>
  makeStyles({ name: 'ActionButtons' })({
    actionButtonSection: {
      padding: '0.5em 1em',
      paddingBlock: '1em',
      display: 'flex',
      justifyContent: 'space-between',
    },
    button: {
      margin: '0',
      '@media screen and (forced-colors: active), @media screen and (-ms-high-contrast: active)': {
        border: '2px solid ButtonText',
        color: 'ButtonText',
        outline: 'revert',
        backgroundColor: 'ButtonFace',
        '&:focus': {
          outlineOffset: '4px',
          outline: '1px dotted ButtonText',
        },
      },
    },
  })();
